import React from "react";
import { Container } from "react-bootstrap";
import { useParams } from "react-router-dom";
import PdfViewerCard from "../../PdfViewerCard";
import procedimientos from "./procedimientosRH";
import "../../incidentes.css";

const ProcedimientoRH = () => {
  const { slug } = useParams();
  const procedimiento = procedimientos.find((p) => p.slug === slug);

  if (!procedimiento) {
    return (
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Procedimiento no encontrado</h1>
        </div>
      </Container>
    );
  }

  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/${procedimiento.pdf}`;

  return (
    <Container fluid className="background-containerr">
      <div className="orgproc-header">
        <h1 className="orgproc-heading">{procedimiento.titulo}</h1>
      </div>
      {procedimiento.slug === "incidencias-rh" && (
        <div className="orgproc-card-actions">
          <a
            className="orgproc-qr"
            href="https://netjernetworksproduccion.odoo.com/vacaciones-rh"
            target="_blank"
            rel="noopener noreferrer"
            title="Ir al Sitio de Incidencias"
          >
            <img
              src={`${process.env.PUBLIC_URL || ""}/img/qr-code.png`}
              alt="Código QR: Ir al Sitio de Incidencias"
            />
            <span className="orgproc-qr-caption">Escanéame</span>
          </a>
        </div>
      )}
      <PdfViewerCard pdfUrl={pdfUrl} titulo={procedimiento.titulo} />
    </Container>
  );
};

export default ProcedimientoRH;